import React, {
  useEffect,
  useState
} from "react";

import {
  Link,
  useNavigate
} from "react-router-dom";

import OfferTable from "../components/OfferTable";
import OfferFilters from "../components/OfferFilters";

import {
  useOffers
} from "../hooks/useOffers";

import {
  OFFER_STATUS
} from "../constants/offer.constants";

import Loader from "../../../components/common/Loader";
import ErrorMessage from "../../../components/common/ErrorMessage";
import EmptyState from "../../../components/common/EmptyState";
import Button from "../../../components/common/Button";


const OffersPage = () => {
  const navigate = useNavigate();

  const {
    offers,
    loading,
    error,
    fetchOffers
  } = useOffers();

  const [
    filters,
    setFilters
  ] = useState({
    status: "",
    clientId: "",
    queryId: ""
  });


  useEffect(() => {
    loadOffers();
  }, [
    filters.status,
    filters.clientId,
    filters.queryId
  ]);


  const loadOffers = async () => {
    await fetchOffers({
      status:
        filters.status || undefined,

      clientId:
        filters.clientId || undefined,

      queryId:
        filters.queryId || undefined
    });
  };


  const handleFilterChange = (
    name,
    value
  ) => {
    setFilters((previous) => ({
      ...previous,
      [name]: value
    }));
  };


  const handleClearFilters = () => {
    setFilters({
      status: "",
      clientId: "",
      queryId: ""
    });
  };


  if (loading) {
    return <Loader />;
  }


  return (
    <div className="offers-page">

      <div className="page-header">

        <div>
          <h1>Offers</h1>

          <p>
            Create, manage and track
            client offers.
          </p>
        </div>


        <Button
          onClick={() =>
            navigate("/offers/create")
          }
        >
          Create Offer
        </Button>

      </div>


      <OfferFilters
        filters={filters}
        onChange={
          handleFilterChange
        }
        onClear={
          handleClearFilters
        }
      />


      {error && (
        <ErrorMessage
          message={error}
        />
      )}


      {!loading &&
        !error &&
        offers.length === 0 && (
          <EmptyState
            title="No offers found"
            message={
              filters.status ||
              filters.clientId ||
              filters.queryId
                ? "No offers match your filters."
                : "You have not created any offers yet."
            }
            action={
              !(
                filters.status ||
                filters.clientId ||
                filters.queryId
              ) ? (
                <Link
                  to="/offers/create"
                >
                  Create your first offer
                </Link>
              ) : null
            }
          />
        )}


      {!loading &&
        offers.length > 0 && (
          <OfferTable
            offers={offers}
            onView={(offer) =>
              navigate(
                `/offers/${offer.id}`
              )
            }
            onEdit={(offer) =>
              navigate(
                `/offers/${offer.id}/edit`
              )
            }
          />
        )}

    </div>
  );
};


export default OffersPage;